import { render, staticRenderFns } from "./AddExcel.vue?vue&type=template&id=24aa5e35&scoped=true"
import script from "./AddExcel.vue?vue&type=script&lang=js"
export * from "./AddExcel.vue?vue&type=script&lang=js"
import style0 from "./AddExcel.vue?vue&type=style&index=0&id=24aa5e35&scoped=true&lang=css"
import style1 from "./AddExcel.vue?vue&type=style&index=1&id=24aa5e35&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa5e35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24aa5e35')) {
      api.createRecord('24aa5e35', component.options)
    } else {
      api.reload('24aa5e35', component.options)
    }
    module.hot.accept("./AddExcel.vue?vue&type=template&id=24aa5e35&scoped=true", function () {
      api.rerender('24aa5e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/AddExcel.vue"
export default component.exports